import { css } from '@emotion/react';

import { breakpoints } from '@coursera/cds-common';

import generateEmotionClasses from '@core/utils/generateEmotionClasses';

export const classes = generateEmotionClasses('Content', ['root']);

const getContentCss = css`
  &.${classes.root} {
    padding: 0 var(--cds-spacing-200);
    ${breakpoints.up('sm')} {
      padding: 0 var(--cds-spacing-200);
    }

    ${breakpoints.up('md')} {
      padding: 0 var(--cds-spacing-300);
    }
  }
`;

export default getContentCss;
